import { TOGGLE_MENU, CLOSE_MENU } from '../ActionsType';

export default function(state = true, action) {
  switch (action.type) {
    case TOGGLE_MENU:
      return action.value;
    case CLOSE_MENU:
      return false;
    default:
      return state;
  }
}